import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Markdown from '../common/Markdown';
import { LIGHT_GRAY } from '../../common/colors';

// Webflow section_faq2 accordion; answers render as markdown.
const FaqAccordion = ({ faqs, withBorder }) => {
  let border = withBorder ? '12px' : 0
  return (
  <div id="faq">
    {faqs.map(({ question, answer }, i) => (
      <Accordion
        key={question}
        disableGutters
        elevation={0}
        sx={{ borderTop: `1px solid ${LIGHT_GRAY}`, '&:last-of-type': { borderBottom: `1px solid ${LIGHT_GRAY}`, borderBottomRightRadius: border, borderBottomLeftRadius: border }, '&:first-of-type': { borderTopRightRadius: border, borderTopLeftRadius: border }, '&:before': { display: 'none' } }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ py: 1 }} id={`faq-${i}-header`} aria-controls={`faq-${i}-content`}>
          <Typography sx={{ fontWeight: 600, color: 'surface.dark', fontSize: '1.125rem' }}>
            {question}
          </Typography>
        </AccordionSummary>
        {/* MUI gives the details' region its id and aria-labelledby from the
            summary's aria-controls and id; repeating them here duplicated both. */}
        <AccordionDetails sx={{ pt: 0 }}>
          <Markdown>{answer}</Markdown>
        </AccordionDetails>
      </Accordion>
    ))}
  </div>
  );
}

export default FaqAccordion;
